'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModalInstance', 'org', '$security', 'CountryService', 'MunicipalityService', 'OkvedService', 'OrgService', 'DaDataService', '$q', 'Notification', '$scope',
                function($modalInstance, org, $security, CountryService, MunicipalityService, OkvedService, OrgService, DaDataService, $q, Notification, $scope) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.changeCodeOkved = changeCodeOkved;
                    $scope.replaceComma = replaceComma;
                    $scope.editing = editing;
                    $scope.isShowEdit = isShowEdit;
                    $scope.findByInn = findByInn;

                    $scope.dateFormat = 'yyyy';
                    $scope.datepickerOptions = {
                        datepickerMode: 'year',
                        minMode: 'year',
                        maxMode: 'year',
                        showWeeks: false,
                    };

                    $scope.innCheckStarted = false;

                    // инициализация
                    init();

                    // region Function

                    function init() {
                        $scope.codeOkved = null;
                        $scope.edit = false;
                        $scope.org = angular.copy(org);

                        if (org == null || org.id == null) {
                            $scope.title = 'Создание новой организации';
                            $scope.edit = true;
                        } else {
                            $scope.title = `Редактирование организации "${org.shortName}"`;
                            $scope.edit = false;
                        }

                        if ($scope.org.okved) {
                            $scope.codeOkved = $scope.org.okved.code;
                        }

                        if (!$scope.org.okveds) {
                            $scope.org.okveds = [];
                        }

                        if ($scope.org != null && $scope.org.id != null) {
                            OrgService.api.okveds({orgId: $scope.org.id}, (data) => $scope.org.okveds = data._embedded);
                        }

                        CountryService.api.getDefault(null, (data) => {
                            if (!$scope.org.regCountry) {
                                $scope.org.regCountry = data._embedded;
                            }
                        });

                        OrgService.api.types({
                            filters: [`'status' EQ 'ENABLED'`],
                            sorts: ['npp:ASC', 'name:ASC'],
                        }, (data) => {
                            $scope.types = data._embedded;
                            $scope.typesObject = $scope.types.reduce((acc, red) => {
                                acc[red.value] = red.title;
                                return acc;
                            }, {});
                        });

                        MunicipalityService.api.get({
                            filters: [`'status' EQ 'ENABLED'`],
                            sorts: ['npp:ASC', 'name:ASC'],
                        }, (data) => {
                            $scope.municipalities = data._embedded
                            const currectMun = $scope.org ? data._embedded.find(municipality => municipality.id === $scope.org.municipality) : null;
                            $scope.currentMunicipality = currectMun ? currectMun.name : "";
                        });
                    }

                    function ok() {
                        $modalInstance.close($scope.org);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function changeCodeOkved(valid) {
                        if (valid && $scope.codeOkved != null && $scope.codeOkved.length != 0) {
                            getOkved($scope.codeOkved).then((okved) => $scope.org.okved = okved);
                        } else {
                            $scope.org.okved = null;
                        }
                    }

                    function replaceComma() {
                        $scope.codeOkved = $scope.codeOkved.replace(/,/g, '.');
                    }

                    /**
                     * Редактировать
                     */
                    function editing() {
                        $scope.edit = true;
                    }

                    /**
                     * Отображать кнопку редактировать?
                     * @returns {boolean|*}
                     */
                    function isShowEdit() {
                        return !$scope.edit && $security.isAllowWrite('/orgs');
                    }

                    function findOrganization(organizationSuggestions) {
                        organizationSuggestions = organizationSuggestions.filter((org) => {
                            return org.data.state.status === 'ACTIVE';
                        });

                        if (organizationSuggestions[0].data.type === 'LEGAL') {
                            organizationSuggestions = organizationSuggestions.filter((org) => org.data.branch_type === 'MAIN');
                        }

                        return organizationSuggestions[0].data;
                    }

                    function getOkved(okvedCode) {
                        return $q(function(resolve, reject) {
                            if (!okvedCode) return resolve(null);

                            OkvedService.api.get({
                                                     searchs: [`'code':'${okvedCode}'`],
                                                     page: 0,
                                                     size: 1,
                                                 }, (data) => {
                                if (data._embedded != null && Array.isArray(data._embedded) && data._embedded.length > 0) {
                                    resolve(data._embedded[0]);
                                } else {
                                    resolve(null);
                                }
                            });
                        });
                    }

                    function changeOkved(okvedCode) {
                        $scope.codeOkved = okvedCode;
                        getOkved(okvedCode).then((okved) => $scope.org.okved = okved);
                    }

                    function findByInn() {
                        if (!$scope.org.inn) return;

                        DaDataService.findByInn($scope.org.inn)
                                     .then((data) => {
                                         if (!data.suggestions.length) {
                                             Notification.warning({
                                                                      title: 'Внимание!',
                                                                      message: `Организация с ИНН ${$scope.org.inn} не найдена.`,
                                                                  });
                                         }

                                         let organizationSuggestion = findOrganization(data.suggestions);

                                         $scope.org.fullName = organizationSuggestion.name.full_with_opf;
                                         $scope.org.shortName = organizationSuggestion.name.short_with_opf;

                                         $scope.org.regYear = new Date(organizationSuggestion.state.registration_date).getFullYear();
                                         $scope.org.regNum = organizationSuggestion.ogrn;

                                         $scope.org.address = organizationSuggestion.address.unrestricted_value;
                                         $scope.org.post = organizationSuggestion.address.unrestricted_value;

                                         let countryName = organizationSuggestion.address.data.country;
                                         if (!!countryName) {
                                             CountryService.api.get({
                                                                        searchs: [`'name':'${countryName}'`],
                                                                        page: 0,
                                                                        size: 1,
                                                                    }, (data) => {
                                                 if (data._embedded != null && Array.isArray(data._embedded) && data._embedded.length > 0) {
                                                     $scope.org.regCountry = data._embedded[0];
                                                 } else {
                                                     $scope.org.regCountry = null;
                                                 }
                                             });
                                         } else {
                                             $scope.org.regCountry = null;
                                         }

                                         let okvedCode = organizationSuggestion.okved;
                                         if (!!okvedCode) {
                                             changeOkved(okvedCode);
                                         } else {
                                             $scope.codeOkved = null;
                                             $scope.org.okved = null;
                                         }

                                         if (!!organizationSuggestion.okveds) {
                                             Promise.all(organizationSuggestion.okveds.map((okved) => getOkved(okved.code)))
                                                    .then((okveds) => $scope.org.okveds = okveds.filter((okved) => !!okved));
                                         }

                                         $scope.org.fax = null;
                                         $scope.org.website = null;

                                         if (organizationSuggestion.type === 'LEGAL') {
                                             $scope.org.bossPosition = organizationSuggestion.management.post;
                                             $scope.org.bossName = organizationSuggestion.management.name;
                                         } else if (organizationSuggestion.type === 'INDIVIDUAL') {
                                             if (!!organizationSuggestion.management) {
                                                 $scope.org.bossPosition = organizationSuggestion.management.post;
                                                 $scope.org.bossName = organizationSuggestion.management.name;
                                             } else {
                                                 $scope.org.bossPosition = null;
                                                 $scope.org.bossName = organizationSuggestion.name.full;
                                             }
                                         }
                                     });
                    }

                    // endregion

                    // region Watcher

                    $scope.$watch('org.okved', (nw) => {
                        if (!!nw) {
                            $scope.codeOkved = nw.code;
                        } else {
                            $scope.codeOkved = null;
                        }
                    });

                    // endregion
                }];
